import { Menu, MenuItem, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';
import Iconify from "./Iconify";
import RouterLink from "./RouterLink";
import { useWeb3React } from "@web3-react/core"; 
import useSettings from "../hooks/useSettings"; 
const MenuAction = styled('div')(({ theme }) => ({
    color:(theme.palette.mode==='dark'?'white':'black'),
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    "&:hover": { borderBottom: `1px solid ${theme.palette.primary.main}`, marginBottom: '-1px' }
}))

DropdownMenu.propTypes = {
    menu: PropTypes.object,
}
export default function DropdownMenu({ menu }) {
   // const [myProfileInfo, setMyProfileInfo] = useState({})
   const { themeMode, onToggleMode } = useSettings();   
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
/*     const { account } = useWeb3React();
 
    useEffect(() => {
        if(account){
           
        }
    }, [account]);
 */
    return (
        <Stack gap={2}>
            <MenuAction onClick={handleClick} >
                {!menu.elements &&
                    <RouterLink to={menu.path}>{menu.title}</RouterLink>
                }
                {menu.elements &&
                    <div >{menu.title}<Iconify icon={"bx:chevron-down"} /></div>
                }
            </MenuAction>
            {menu.elements &&
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    {menu.elements.map((item, index) => {
            /*             if (!account && (item.notLoginVisible !== undefined))
                            return;
                        if (account && myProfileInfo?.brandPartnerStatus != 'accepted' && item.notLoginVisible === 'brandPartner')
                            return; */
                        
                        return <MenuItem key = {index} onClick = {handleClose}>
                            {item.outLink ? <a href={item.path} style={{color: themeMode === 'light' ?'black':'white', textDecoration:'none'}} target="_blank"  >{item.title}</a> 
                            : <RouterLink to = {item.path} >{item.title}</RouterLink>}
                        </MenuItem>
                    })}

                </Menu>
            }
        </Stack>
    )
}
